module.exports = __webpack_public_path__ + "img/dianwang-min.bbc28813.jpg";